import { Component, EventEmitter, Output } from '@angular/core';
import { Company, CompaniesService, CompanyStatus } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { ERROR_COMPANY_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-home-evaluation-companies',
  templateUrl: './home-evaluation-companies.component.html',
  styleUrls: ['./home-evaluation-companies.component.scss'],
})
export class HomeEvaluationCompaniesComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = false;
  companies?: Company[];

  constructor(
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  ngOnInit(): void {
    this.listCompanies();
  }

  onRefresh(): void {
    this.listCompanies();
  }

  onSeeAllClick(): void {
    this.navigation_service.toCompanies();
  }

  listCompanies(): void {
    this.is_list_running = true;
    const status = CompanyStatus.pending_evaluation;
    this.companies_service.listCompanies({ status }).subscribe({
      next: response => {
        this.companies = response.data.data;
        this.companies = this.companies?.slice(0, 5);
        this.is_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_COMPANY_NOT_FOUND) {
          this.companies = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
      },
    });
  }
}
